module.exports = __webpack_public_path__ + "static/img/logo03.21e8bf02.png";